import axios from 'axios';

export function searchWord(word) {
  return dispatch => axios.get(`${process.env.REACT_APP_API_HOST}/api/tools/lang/entries/${word}`);
}

export function thesaurusSearch(word) {
  return dispatch => axios.get(`${process.env.REACT_APP_API_HOST}/api/tools/lang/thesaurus/${word}`);
}